'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTab = selectTab;

var _types = require('./types');

function selectTab(route, key) {
  return {
    type: _types.SELECT_TAB,
    route: route,
    key: key
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/PageFooter/actions.js
// module id = 1109
// module chunks = 0